import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const VyrobcePneu = {
	name: NAME,
	apiProvider,
	router,
};
